export default __webpack_public_path__ + "static/media/feralgrowl.e4ded318.png";